import { useContext } from "react"
import { SiteContext } from "@lib/contexts"

export const useSite = () => {
  const site: any = useContext(SiteContext)

  return site
}
